import { ActionController } from "@g.frame/common.action_controller";
import { FBX_MODEL, Loader, TEXTURE } from "@g.frame/common.loaders";
import { ViewerModule } from "@g.frame/core";
import { AnimationMixer, Clock, LoopOnce, MeshStandardMaterial } from "three";
export default class CowComponent extends ViewerModule {
    constructor(modulesProcessor) {
        super();
        this.modulesProcessor = modulesProcessor;
        this.loader = this.modulesProcessor.agents.get(Loader);
        this.actionController = this.modulesProcessor.agents.get(ActionController);
        this.loader.addResources([
            {
                name: 'MODEL_cow',
                url: require('../../../assets/models/cow/cow.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'TEXTURE_cow_albedo',
                url: require('../../../assets/textures/cow/Cow_Albedo_2_1k.png'),
                type: TEXTURE
            }
        ]);
    }
    init() {
        this.initModel();
        this.runIdleAnimation();
    }
    initModel() {
        this.cow = this.loader.getResource('MODEL_cow');
        this.cow.scale.set(0.01, 0.01, 0.01);
        this.addObject(this.cow);
        this.initMaterials();
        this.prepareAnimations();
        this.initMixer();
    }
    initMaterials() {
        const material = new MeshStandardMaterial({
            map: this.loader.getResource('TEXTURE_cow_albedo'),
        });
        const cowMesh = this.cow.getObjectByName('Cow_LOD0');
        cowMesh.material = material;
    }
    prepareAnimations() {
        // const animList = ['Arm_Cow|Idle_2', 'Arm_Cow|Idle_3', 'Arm_Cow|Arm_Cow|Arm_Cow|Idle_2|Arm_Cow|Idle_2'];
        const animList = ['Arm_Cow|Idle_2', 'Arm_Cow|Idle_3'];
        this.clips = [];
        animList.map((name) => {
            this.cow.animations.forEach((animation) => {
                if (animation.name === name) {
                    this.clips.push(animation);
                }
            });
        });
    }
    initMixer() {
        this.mixer = new AnimationMixer(this.cow);
        const clock = new Clock();
        this.modulesProcessor.viewer.on('update', () => {
            this.mixer.update(clock.getDelta());
        });
    }
    runIdleAnimation() {
        this.activeClip = this.mixer.clipAction(this.clips[0]);
        this.activeClip.loop = LoopOnce;
        this.activeClip.play();
        this.activeClip.clampWhenFinished = true;
        this.mixer.addEventListener('finished', (e) => {
            this.repeatIdleAnimation();
        });
    }
    repeatIdleAnimation() {
        if (this.activeClip) {
            this.activeClip.stop();
            this.activeClip.time = 0;
        }
        const index = Math.floor(Math.random() * 2);
        this.activeClip = this.mixer.clipAction(this.clips[index]);
        this.activeClip.loop = LoopOnce;
        this.activeClip.clampWhenFinished = true;
        this.activeClip.play();
    }
}
